module.exports = __webpack_public_path__ + "media/entities/1115-3cc6b343.png";